<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="title" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false" :before-close="handleClose">
            <div>
                <div>
                    <el-form>
                        <div class="el-table el-table--fit el-table--border">
                            <div class="el-table__body-wrapper">
                                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                    <tbody>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">任务编号</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterData.taskCode }}</td>
                                        </tr>

                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">任务名称</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterData.title }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">任务内容</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterData.content }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">开始日期</td>
                                            <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.startDate }}</td>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">完成时限</td>
                                            <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.overDate }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">主办部门</td>
                                            <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.qtDept }}</td>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">配合部门</td>
                                            <td colspan="2" class="el-table__cell tdcont tdw33">{{ matterData.phDept }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">附件</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">
                                                <Attachment
                                                v-if="matterData.passenger"
ref="attachments" :vo="matterData" :is-required="0" accept="*.*" empty-message="" wf-attach-url="" :limit-count="10" online-editor="" online-file="/dcdb/task/donwload" :attachments="matterData.passenger.attachments"
			  			:attachs-type="'ATTACH'" :is-drag="0" :auto-upload="0"
/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">办结方式</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">{{ concludeTypeFn(matter.concludeType) }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">办结日期</td>
                                            <td colspan="2" class="el-table__cell tdcont tdw33">{{ matter.completeTime }}</td>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">办结人</td>
                                            <td colspan="2" class="el-table__cell tdcont tdw33">{{ matter.concludePerson }}</td>
                                        </tr>

                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">办结情况说明</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterFinish.finishContent }}</td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'remark'" colspan="1" class="el-table__cell tdlbl tdw17">备注</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">{{ matterFinish.remark }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="1" class="el-table__cell tdlbl tdw17">附件</td>
                                            <td colspan="5" class="el-table__cell tdcont tdw83">
                                                <Attachment
                                                v-if="matterFinish.passenger"
ref="attachments" :vo="matterFinish" :is-required="0" accept="*.*" empty-message="" wf-attach-url="" :limit-count="10" online-editor="" online-file="/dcdb/matterFinish/donwload" :attachments="matterFinish.passenger.attachments"
			  			:attachs-type="'ATTACH'" :is-drag="0" :auto-upload="0"
/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            if (!val) return ''
            return moment(new Date(val)).format('YYYY年MM月DD日')
        }
    },
    components: {},
    props: {},
    data() {
        return {
            title: '',
            dialogVisible: false,
            loginUser: this.$store.getters.loginUser,
            activeName: 'first',
            matterData: {},
            matter: {},
            matterFinish: {},
            tableData: [],
            formTitle: '',
            BusiFormShow: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.rowId = this.$route.query.id
        this.$bus.on('openRwbjFormDialog', this.openRwbjFormDialog)
    },
    beforeDestroy() {
        this.$bus.off('openRwbjFormDialog', this.openRwbjFormDialog)
    },
    mounted() {},
    methods: {
        concludeTypeFn(val) {
            let str = ''
            switch (val) {
                case 1:
                    str = '手动办结'
                    break
                case 2:
                    str = '流程审批办结'
                    break
                default:
                    break
            }
            return str
        },
        taskStatusFn(val) {
            var str = val
            switch (val) {
                case 0:
                    str = '未交办'
                    break
                case 1:
                    str = '执行中'
                    break
                case 2:
                    str = '已完成'
                    break
                case 3:
                    str = '已办结'
                    break
                case 4:
                    str = '办结中'
                    break
                case 8:
                    str = '已归档'
                    break
                case 9:
                    str = '已取消'
                    break
                default:
                    break
            }
            return str
        },

        openRwbjFormDialog(row) {
            this.title = '任务办结'
            this.matterData = row.dbTask
            this.matter = row.matter || {}
            this.matterFinish = row.matterFinish || {}
            this.dialogVisible = true
        },

        handleClick(val) {
            console.log('val', val)
        },
        // 弹出关闭
        handleClose() {
            this.tableData = []
            this.matterData = {}
            this.activeName = 'first'
            this.dialogVisible = false
        }

    }
}
</script>

<style scoped lang="scss">
</style>
